var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5833 19.1667C32.075 19.1667 31.5875 18.9647 31.228 18.6053C30.8686 18.2458 30.6667 17.7583 30.6667 17.25V11.5C30.6667 9.46667 29.8589 7.51663 28.4212 6.07885C26.9834 4.64107 25.0333 3.83333 23 3.83333C20.9667 3.83333 19.0166 4.64107 17.5788 6.07885C16.1411 7.51663 15.3333 9.46667 15.3333 11.5V17.25C15.3333 17.7583 15.1314 18.2458 14.772 18.6053C14.4125 18.9647 13.925 19.1667 13.4167 19.1667C12.9083 19.1667 12.4208 18.9647 12.0614 18.6053C11.7019 18.2458 11.5 17.7583 11.5 17.25V11.5C11.5 8.45001 12.7116 5.52494 14.8683 3.36827C17.0249 1.2116 19.95 0 23 0C26.05 0 28.9751 1.2116 31.1317 3.36827C33.2884 5.52494 34.5 8.45001 34.5 11.5V17.25C34.5 17.7583 34.2981 18.2458 33.9386 18.6053C33.5792 18.9647 33.0917 19.1667 32.5833 19.1667Z",
    fill: "url(#paint0_linear_59_25452)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5 17.25H11.5C8.32436 17.25 5.75 19.8244 5.75 23V38.3333C5.75 41.509 8.32436 44.0833 11.5 44.0833H34.5C37.6756 44.0833 40.25 41.509 40.25 38.3333V23C40.25 19.8244 37.6756 17.25 34.5 17.25ZM22.9997 38.3333C22.4913 38.3333 22.0038 38.1314 21.6444 37.772C21.2849 37.4125 21.083 36.925 21.083 36.4167V32.0701C19.9376 31.4073 19.167 30.1686 19.167 28.75C19.167 26.6329 20.8832 24.9167 23.0003 24.9167C25.1174 24.9167 26.8337 26.6329 26.8337 28.75C26.8337 30.1692 26.0625 31.4082 24.9163 32.0709V36.4167C24.9163 36.925 24.7144 37.4125 24.355 37.772C23.9955 38.1314 23.508 38.3333 22.9997 38.3333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_25452",
    x1: 23,
    y1: 0.366083,
    x2: 23,
    y2: 17.2193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.594c9240d8dd82e4b1a4022c836262b8.svg";
export { ForwardRef as ReactComponent };